export const DEVICE_TROUBLESHOOTING_MODAL_PREFIX = 'device-troubleshoot_';

export const reasonForCallOptions = [
  {
    key: 'introductoryCall',
    label: 'Introductory Call',
    value: 'introductoryCall',
  },
  {
    key: 'normalReadings',
    label: 'Normal Readings',
    value: 'normalReadings',
  },
  {
    key: 'deviceTroubleshoot',
    label: 'Device Troubleshoot',
    value: 'deviceTroubleshoot',
  },
  {
    key: 'noReadings',
    label: 'No Readings',
    value: 'noReadings',
  },
  {
    key: 'monthlyInteractionCall',
    label: 'Monthly Interaction Call',
    value: 'monthlyInteractionCall',
  },
  {
    key: 'other',
    label: 'Other',
    value: 'other',
  },
];

export const reviewCareTeamContactInfoOptions = [
  {
    key: 'takeReadingsRegularly',
    label: `You can start taking your readings regularly right away. Try to be consistent with when and how you take them`,
    value: 'takeReadingsRegularly',
  },
  {
    key: 'safeRangeExplained',
    label: `Your provider has determined what your safe or “in range” numbers are (review thresholds with patient)`,
    value: 'safeRangeExplained',
  },
  {
    key: 'outOfRangeCall',
    label: `If you have a reading that’s outside of that safe range, you will get a call from a nurse to ask questions about how you’re feeling and help determine if your provider needs to take action`,
    value: 'outOfRangeCall',
  },
  {
    key: 'monthlyCheckins',
    label: `You will also get a regular monthly text message and phone call from a medical assistant`,
    value: 'monthlyCheckins',
  },
  {
    key: 'textMessageForm',
    label: `The text message contains a link to a form you can fill out online`,
    value: 'textMessageForm',
  },
  {
    key: 'checkupCall',
    label: `The call is just a normal “check up” call. We’ll look at how your readings have been doing, take care of any needs you might have, and help you set and achieve your personal health goals`,
    value: 'checkupCall',
  },
];

export const reasonForCallObj = {
  introductoryCall: 'Introductory Call',
  normalReadings: 'Normal Readings',
  deviceTroubleshoot: 'Device Troubleshoot',
  noReadings: 'No Readings',
  monthlyInteractionCall: 'Monthly Interaction Call',
};
